import {NAME_SPACE} from "@kta20-core/constants";

//Auth events the app expects to be fired from any auth-module
// (kta20-modules/*) will be implemented and
//configured for use in the profile (./app/profiles/*)
export const AuthServiceEvents = {
    SESSION_STARTED: `${NAME_SPACE}.authevents.SESSION_STARTED`,
    SESSION_EXPIRED: `${NAME_SPACE}.authevents.SESSION_EXPIRED`,
    SESSION_ABOUT_TO_EXPIRE: `${NAME_SPACE}.authevents.SESSION_ABOUT_TO_EXPIRE`
};